<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import clsx from "clsx";
  import Block from "../Block.svelte";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  export let blocks: any[];
</script>

<!-- Template ----------------------------------------------------------------->

{#if blocks}
  <div class="container text-white">
    <div
      class={clsx(
        "prose prose-invert max-w-[900px] m-auto", // prose setup
        "prose-hr:border-secondary-s500 prose-hr:mt-8", // customize prose <hr />
      )}
    >
      {#each blocks as block}
        <Block {block} />
      {/each}
    </div>
  </div>
{/if}
